/*
 * @Author: Kida
 * @Date: 2020-11-18 09:42:27
 * @LastEditTime: 2021-01-21 14:34:53
 * @LastEditors: Please set LastEditors
 * @Description: 数学工具类
 * @FilePath: \vr-fornt-end\src\components\modeldemo\Tool\MathTools.js
 */

import { MathUtils } from 'three'

export function dlon (slon, tlon) {
  let dl = (tlon - slon + 360) % 360
  dl = dl > 180 ? dl - 360 : dl
  return dl
}

export function addLon (slon, dlon) {
  return (slon + 540 + dlon) % 360 - 180
}

/**
 *
 * @param {THREE.Vector3} dir 方向,可以不归一化
 */
export function dirToLonLat (dir) {
  dir.normalize()
  dir.y = dir.y >= 1 ? 1 : dir.y <= -1 ? -1 : dir.y

  const lat = MathUtils.radToDeg(Math.asin(dir.y))
  let lon = 0
  if (dir.y !== -1 && dir.y !== 1) {
    if (dir.x === 0) {
      lon = dir.z > 0 ? 90 : -90
    } else {
      lon = MathUtils.radToDeg(Math.atan(dir.z / dir.x))
      lon = dir.x > 0 ? lon : dir.z >= 0 ? lon + 180 : lon - 180
    }

    lon = lon > 180 ? lon - 360 : lon
  }

  return { lon: lon, lat: lat }
}

export const cos45 = Math.cos(MathUtils.degToRad(45))
